import styled from 'styled-components';
import { colors, dimensions } from 'modules/common/styles';

const imageSize = 30;

const Members = styled.div`
  padding-top: ${dimensions.unitSpacing - 5}px;
`;

const MemberImg = styled.img`
  width: ${imageSize}px;
  height: ${imageSize}px;
  border-radius: ${imageSize / 2}px;
  background: ${colors.bgActive};
  border: 2px solid ${colors.colorWhite};
  margin-left: -8px;

  &:first-child {
    margin-left: 0;
  }
`;

const DataWrapperClass = styled.div`
  section.sc-iELTvK.dgWnOn {
    background: #fff;
    margin-left: 20px;
    margin-right: 20px;
  }
  section.sc-jtRfpW.daxgFZ {
    margin-right: 20px;
  }
  section.sc-iELTvK.dstvIj {
    background: #fff;
    margin-left: 20px;
  }
`;

const More = MemberImg.withComponent('span').extend`
  color: ${colors.colorWhite};
  text-align: center;
  vertical-align: middle;
  font-size: ${dimensions.unitSpacing}px;
  background: ${colors.colorCoreLightGray};
  display: inline-block;
  line-height: ${dimensions.coreSpacing + 6}px;
  cursor: pointer;
`;

const ModalSmallIconButton = styled.div`
  display: flex;
  margin-top: 22px;
`;

export { MemberImg, Members, More, DataWrapperClass, ModalSmallIconButton };


// WEBPACK FOOTER //
// src/modules/screens/settings/SmsProvider/styles.js